import {saveAs} from "file-saver";

export const download = (data, filename) => {
    const dataBlob = new Blob([data], {type : ""});
    saveAs(dataBlob,filename);
    localStorage.removeItem ('filename');
};



// WEBPACK FOOTER //
// ./src/lib/downloadLogic.js